import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiUsagesFetchFailedAction = {
	type: 'AI_USAGES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiUsagesFetchFailedAction => ({
	type: 'AI_USAGES_FETCH_FAILED',
	payload,
});
